import { pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import Button from "./Button";

export const Label = styled.label`
  margin-bottom: ${pxToRem(4)};
`;
export const Input = styled.input`
  border: ${pxToRem(1)} solid ${({ theme }) => theme.grey_200};

  &[type="checkbox"] {
    margin-right: ${pxToRem(8)};
  }

  &[type="text"],
  [type="password"] {
    padding: ${pxToRem(8)};
    font-size: ${pxToRem(14)};
  }
`;
export const InputDescription = styled.div`
  font-size: ${pxToRem(12)};
  font-weight: 400;
  color: ${({ theme }) => theme.grey_200};
  margin: ${pxToRem(8)} 0 ${pxToRem(0)};
`;
export const ErrorSpan = styled.span`
  color: ${({ theme }) => theme.red};
  font-size: ${pxToRem(14)};
`;

/**
 * Horizontal Flex Rows.
 */
export const FormRow = styled.div`
  display: flex;

  :not(:last-child) {
    margin-bottom: ${pxToRem(20)};
  }

  &.call-to-action {
    margin-top: ${pxToRem(28)};
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  button:not(:last-child) {
    margin-right: 1rem;
  }
`;

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 1rem;
  width: 100%;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  width: 100%;
  padding-top: ${pxToRem(20)};
  border-top: ${pxToRem(1)} solid ${({ theme }) => theme.grey_100};
`;

/* ↓ Playoffs styled Form elements ↓ */

export const ChaseInputGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ChaseInput = styled.input`
  background: transparent;
  border: ${pxToRem(1)} solid white;
  border-radius: 0px;
  padding: ${pxToRem(8)};
  color: white !important;
  font-size: ${pxToRem(12)};

  &:focus-visible {
    outline: none;
  }

  &:focus {
    color: white !important;
  }

  &[type="radio"] {
    width: ${pxToRem(14)};
    height: ${pxToRem(14)};
    margin-right: ${pxToRem(8)};
    padding: ${pxToRem(2)};
    border: ${pxToRem(1.5)} solid white;
    appearance: none;
    background-clip: content-box;
    background-color: transparent;
    transition: background-color 0.3s ease-in-out;

    &:checked {
      background-color: ${({ theme }) => theme.gold};
    }

    &:focus-visible {
      outline: auto;
    }
  }
`;

export const ChaseLabel = styled.label`
  display: block;
  padding-right: ${pxToRem(48)};
  color: ${({ theme }) => theme.grey_150};
  font-size: ${pxToRem(10)};
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0px;
  line-height: ${pxToRem(22)};
`;

export const ChaseStackedRow = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${pxToRem(300)};
  margin: 0 auto ${pxToRem(20)};
  align-items: flex-start;
  text-align: left;
  > * {
    width: 100%;
  }
`;

export const ChaseErrorArea = styled(ChaseStackedRow)`
  color: ${({ theme }) => theme.red};
  font-size: ${pxToRem(12)};
  font-weight: bold;
  text-align: center;
  align-items: center;
`;

/**
 * Centered submit button with bottom spacing.
 */
export const ChaseSubmitBtn = styled(Button)`
  margin: 0 auto ${pxToRem(20)};
`;
